import Vue from "vue";
import Router from "vue-router";
import Top from "./views/Top.vue";
import Concour from "./views/Concour.vue";
import ConcourDetail from "./views/ConcourDetail.vue";
import Event from "./views/Event.vue";
import EventDetail from "./views/EventDetail.vue";
import Teaching from "./views/Teaching.vue";
import TeachingDetail from "./views/TeachingDetail.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/",
      name: "Top",
      component: Top,
      meta: {
        jsonKey: "top",
        jsonPath: "wp-json/custom/top"
      },
      beforeEnter: (to, from, next) => {
        const q = to.query;
        if (q.preview) {
          next(`/${q.post_type}/${q.p}`);
        } else {
          next();
        }
      }
    },
    {
      path: "/concour",
      name: "Concour",
      component: Concour,
      meta: {
        jsonKey: "Concour",
        jsonPath: "wp-json/custom/concour",
        title: "コンクール応募情報 | まなびアサヒ.com"
      }
    },
    {
      path: "/concour/:id",
      name: "ConcourDetail",
      component: ConcourDetail,
      meta: {
        clearDataOnRender: true,
        jsonKey: "ConcourDetail",
        jsonPath: "wp-json/custom/concour-detail"
      }
    },
    {
      path: "/event",
      name: "Event",
      component: Event,
      meta: {
        title: "イベント情報 | まなびアサヒ.com"
      }
    },
    {
      path: "/event/:id",
      name: "EventDetail",
      component: EventDetail,
      meta: {
        clearDataOnRender: true,
        jsonKey: "eventDetail",
        jsonPath: "wp-json/custom/event-detail"
      }
    },
    {
      path: "/teaching",
      name: "Teaching",
      component: Teaching,
      meta: {
        title: "教材情報 | まなびアサヒ.com"
      }
    },
    {
      path: "/teaching/:id",
      name: "TeachingDetail",
      component: TeachingDetail,
      meta: {
        clearDataOnRender: true,
        jsonKey: "teachingDetail",
        jsonPath: "wp-json/custom/teaching-detail"
      }
    }
  ]
});
